import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon, langPage } from "../../../locales";
import { MemberServer } from "../../../server";
import { generateOperationFormConfig, DEFAULT_OPERATION_DATA } from './config'

const server = MemberServer.Manager;
const lang = langPage?.member?.manager;

type OperateModeType = 'create' | 'modify' | 'pwd'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');
    const [roleOptions, setRoleOptions] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode !== 'create' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    useRequest(MemberServer.Role.list, {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setRoleOptions([]);
        },
        onSuccess: (res: any) => {
            setRoleOptions(res?.map((e: any) => ({ id: e.Id, name: e.Name })));
        }
    });

    const { run } = useRequest(mode === 'create' ? server.create : mode === 'pwd' ? server.modifyPwd : server.modify, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? langCommon?.createSuccess : langCommon?.modifySuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode, roleOptions });
    }, [formData, mode, roleOptions]);

    return (
        <div>
            <Modal
                title={mode === 'create' ? `${langCommon?.create}${lang?.manager}` : mode === 'pwd' ? lang?.pwd : `${langCommon?.modify}${lang?.manager}`}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Status, Username, RoleId, Password, Id } = formData
                    const params = {
                        ...(mode !== 'pwd' ? { Username, RoleId, Status } : {}),
                        ...(mode !== 'modify' ? { Password } : {}),
                        Id,
                    }
                    run(params)
                }}
            >
                <EditForm
                    componentId="manager-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 16 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
